import { NavigateFunction } from 'react-router';

import { GaFunnelInfo } from 'types/gaFunnelInfo';

import type { Store } from '../types';

import { STEPS, getStepPathWithCarParam, gotoStep } from './navigation';
import { carContractValidator } from './stepValidators/carContractValidator';

type StepObject = {
	text: string;
	href?: string;
	onClick?: (...args: any[]) => void;
	onKeyPress?: () => void;
};

const isRequiredDataPresentForStep = (step: string, state: Store): boolean => {
	switch (step) {
		case STEPS.USER_INFORMATION:
			return carContractValidator(state);
		case STEPS.OVERVIEW:
			return false;
		case STEPS.THANK_YOU:
			return false;
		default:
			return true;
	}
};

export const handleClick = (
	e: Event,
	step: string,
	eventAction: string,
	navigate: NavigateFunction,
	gaFunnelInfo: GaFunnelInfo
): void => {
	e.stopPropagation();
	e.preventDefault();
	gotoStep(step, eventAction, navigate, gaFunnelInfo, 'progress-bar');
};

export const getStepsPrivateLease = (
	state: Store,
	navigate: NavigateFunction,
	gaFunnelInfo: GaFunnelInfo,
	isFlex?: boolean
): StepObject[] => [
	{
		text: isFlex ? 'Contract samenstellen' : 'Samenstelling auto en contract',
		href: getStepPathWithCarParam(STEPS.CAR_CONTRACT),
		onClick: (e: Event) =>
			handleClick(
				e,
				STEPS.CAR_CONTRACT,
				'1. Samenstelling auto en contract',
				navigate,
				gaFunnelInfo
			),
	},
	{
		text: 'Persoonlijke gegevens',
		...(isRequiredDataPresentForStep(STEPS.USER_INFORMATION, state) && {
			href: getStepPathWithCarParam(STEPS.USER_INFORMATION),
			onClick: (e: Event) =>
				handleClick(e, STEPS.USER_INFORMATION, '2. Persoonlijke gegevens', navigate, gaFunnelInfo),
		}),
	},
	{
		text: 'Gegevens controleren',
		...(isRequiredDataPresentForStep(STEPS.OVERVIEW, state) && {
			href: getStepPathWithCarParam(STEPS.OVERVIEW),
			onClick: (e: Event) =>
				handleClick(e, STEPS.OVERVIEW, '3. Gegevens controleren', navigate, gaFunnelInfo),
		}),
	},
];
